import { create } from 'zustand';
import { ReactNode } from 'react';

export type ConfirmationModalState = {
  isOpen: boolean;
  toggle: () => void;
  handleClose: () => void;
  handleOpen: () => void;
  title: string;
  setTitle: (title: string) => void;
  content: string | ReactNode;
  setContent: (content: string | ReactNode) => void;
  touched: boolean;
  setTouch: (touch: boolean) => void;
  onOk: () => void;
  setOnOK: (fn: () => void) => void;
  error: boolean;
  setError: (error: boolean) => void;
};

export const useConfirmationModalStore = create<ConfirmationModalState>(
  (set) => ({
    isOpen: false,
    touched: false,
    title: '',
    content: '',
    error: false,
    setOnOK: (fn) => set({ onOk: fn }),
    onOk: () => {},
    toggle: () => set((state) => ({ isOpen: !state.isOpen })),
    handleClose: () => set({ isOpen: false }),
    handleOpen: () => set({ isOpen: true }),
    setTitle: (title: string) => set({ title }),
    setContent: (content: string | ReactNode) => set({ content }),
    setTouch: (touched: boolean) => set({ touched }),
    setError: (error: boolean) => set({ error }),
  })
);
